import React from "react";

const HealthMapIcon = ({ height = 24, width = 24, fill = "#F8F6F6" }) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C12.5523 2 13 2.44772 13 3V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V3C11 2.44772 11.4477 2 12 2Z" fill={fill} />
        <circle cx="12" cy="5" r="2.5" fill={fill} />
        <circle cx="12" cy="12" r="2.5" fill={fill} />
        <circle cx="12" cy="19" r="2.5" fill={fill} />
        <path d="M15 5H19" stroke={fill} strokeWidth="1.5" strokeLinecap="round" />
        <path d="M15 12H20" stroke={fill} strokeWidth="1.5" strokeLinecap="round" />
        <path d="M15 19H18" stroke={fill} strokeWidth="1.5" strokeLinecap="round" />
        <path d="M5 5H9" stroke={fill} strokeWidth="1.5" strokeLinecap="round" />
        <path d="M4 12H9" stroke={fill} strokeWidth="1.5" strokeLinecap="round" />
        <path d="M6 19H9" stroke={fill} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);

export default HealthMapIcon;
